// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__P9a0C","options":"AnswerScale_options__1Ri8W","selected":"AnswerScale_selected__pZvqS"};